<template>
  <div v-loading.body="loading">
    <header-tabs :active="$route.path"></header-tabs>
    <el-row class="filter">
      <el-col>
        <div
          style="
            background: #f3f3f3;
            height: 30px;
            line-height: 30px;
            padding: 0 25px;
            display: flex;
            align-items: center;
          "
        >
          <div>筛选查询</div>
          <el-button
            type="text"
            style="margin-left: auto"
            :icon="filterFold ? 'el-icon-arrow-down' : 'el-icon-arrow-up'"
            @click="toggleFilter"
          >
            {{ filterFold ? "展开筛选" : "收起筛选" }}
          </el-button>
        </div>
        <el-collapse-transition>
          <div v-show="!filterFold">
            <div style="padding: 10px 25px">
              <el-col :span="24">
                <el-form :inline="true" :model="form" class="demo-form-inline">
                  <el-form-item label="输入搜索：">
                    <el-input
                      v-model="form.search_user_id"
                      placeholder="用户id"
                      @keyup.native.enter="search"
                    ></el-input>
                  </el-form-item>
                  <el-form-item>
                    <el-input
                      v-model="form.space"
                      placeholder="仓位"
                      @keyup.native.enter="search"
                    ></el-input>
                  </el-form-item>
                  <el-form-item>
                    <el-select
                      v-model="form.is_label"
                      placeholder="是否开启仓库改标"
                    >
                      <el-option
                        v-for="item in is_label"
                        :key="item.key"
                        :label="item.name"
                        :value="item.key"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item>
                    <el-button type="primary" @click="search">查询</el-button>
                    <el-button type="primary" @click="reset">重置</el-button>
                  </el-form-item>
                </el-form>
              </el-col>
            </div>
          </div>
        </el-collapse-transition>
      </el-col>
    </el-row>

    <!-- 表格 -->
    <el-row v-if="!loading">
      <el-col style="border: 1px solid #ddd">
        <div
          style="
            background: #f3f3f3;
            height: 50px;
            line-height: 30px;
            padding: 0 25px;
            display: flex;
            align-items: center;
          "
        >
          <div>数据列表：</div>
          <el-button
            type="primary"
            style="margin-left: auto"
            size="mini"
            @click="output"
            >导出</el-button
          >
        </div>
        <div v-if="resData" style="margin-bottom: 0">
          <el-table height="600" :data="resData.data" style="width: 100%">
            <el-table-column prop="user_id" label="用户id"></el-table-column>
            <el-table-column
              prop="is_label"
              label="是否开启仓库改标"
              width="120"
              align="center"
            ></el-table-column>
            <el-table-column label="改标示例图片" align="center" width="100">
              <template slot-scope="scope">
                <el-image
                  v-if="scope.row.imgs.length > 0"
                  style="width: 100px; height: 100px"
                  :src="scope.row.imgs[0]"
                  :preview-src-list="scope.row.imgs"
                >
                </el-image>
              </template>
            </el-table-column>
            <el-table-column label="改标备注" align="center" width="200">
              <template slot-scope="scope">
                <div v-if="scope.row.label_tag">
                  服务项：{{ scope.row.label_tag }}
                </div>
                <div v-if="scope.row.label_note">
                  备注：{{ scope.row.label_note }}
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="space_txt"
              label="改标仓位"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="admin_name"
              label="更新人"
              width="120"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="update_time"
              label="更新时间"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column label="操作" show-overflow-tooltip align="center">
              <template slot-scope="scope">
                <el-button
                  type="text"
                  size="small"
                  @click="clickDialog(scope.row)"
                  >操作</el-button
                >
                <el-button type="text" size="small" @click="showLog(scope.row)">
                  日志</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div v-if="resData" style="text-align: right; padding: 25px">
          <el-pagination
            :current-page.sync="resData.current_page"
            background
            layout="total, prev, pager, next, jumper ,sizes"
            :total="resData.total"
            :page-size="resData.per_page"
            :page-sizes="[10, 20, 50, 100]"
            @current-change="handleCurrentChange"
            @size-change="handleSizeChange"
          >
          </el-pagination>
        </div>
      </el-col>
    </el-row>

    <el-dialog
      title="编辑"
      :visible.sync="dialogFormVisible"
      :before-close="closeDialog"
      width="40%"
      center
    >
      <el-form :model="editForm">
        <el-form-item label="改标用户">
          <el-input v-model="editForm.user_id" disabled></el-input>
        </el-form-item>
        <el-form-item label="改标仓位">
          <el-input v-model="editForm.space_txt"></el-input>
        </el-form-item>
        <el-form-item label="改标备注">
          <el-tag
            v-for="item in resData.label_tags"
            :key="item"
            class="tag"
            :type="tagType(item)"
            @click="setTag(item)"
          >
            {{ item.label }}
          </el-tag>
          <el-input
            ref="label_note_textarea"
            v-model="editForm.label_note"
            type="textarea"
          ></el-input>
        </el-form-item>
        <el-form-item label="改标示例图片">
          <div class="upload">
            <el-upload
              ref="example_upload"
              class="upload-demo"
              :action="action"
              :on-remove="handleImgRemove"
              :on-success="handleImgSuccess"
              :on-exceed="handleImgExceed"
              list-type="picture-card"
              :file-list="fileList"
              :limit="5"
              with-credentials
            >
              <el-button size="small" type="primary">点击上传</el-button>
              <div slot="tip" class="el-upload__tip">
                只能上传jpg/png文件，且不超过500kb
              </div>
            </el-upload>
          </div>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closeDialog">取 消</el-button>
        <el-button type="primary" @click="save">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog title="操作日志" :visible.sync="dialogTableVisible">
      <el-table :data="gridData">
        <el-table-column
          property="create_time"
          label="操作时间"
          width="250"
        ></el-table-column>
        <el-table-column
          property="action_admin"
          label="操作人"
          width="200"
        ></el-table-column>
        <el-table-column
          property="action_desc"
          label="操作内容"
        ></el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
import HeaderTabs from "./components/HeaderTabs.vue";
import apiBaseURL from "@/utils/baseUrl.js";

export default {
  components: { HeaderTabs },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.fetchData();
    });
  },
  data() {
    return {
      upLoadFilesLength: 0,
      tempSuccessImg: [],
      resData: {},
      gridData: {},
      fileList: [],
      form: {
        origin: 1,
        space: "",
        is_label: "",
        search_user_id: "",
        page: 1,
        pagesize: 50,
      },
      editForm: {
        space_txt: "",
        label_note: "",
        user_id: 0,
        tag: [],
        file_list: [],
      },
      loading: false,
      tableLoading: false,
      url: "/erp/WavePickingTempSummary/getLabelUserSpaceList",
      origin: [
        { origin_id: 1, origin_name: "广州" },
        { origin_id: 2, origin_name: "杭州" },
      ],
      origin_id: 1,
      dialogFormVisible: false,
      dialogTableVisible: false,
      filterFold: false,
      formLabelWidth: "100px",
      is_label: [
        { key: "", name: "全部" },
        { key: 2, name: "否" },
        { key: 1, name: "是" },
      ],
      currentPage: 0,
      action: `${apiBaseURL}/erp/WavePickingTempSummary/uploadUsersLabelImg`,
    };
  },
  computed: {},
  methods: {
    // tableRowClassName({row, rowIndex}) {
    //     if (row.is_stock == 1) {
    //         return 'stock-row';
    //     }
    //     return '';
    // },
    toggleFilter() {
      this.filterFold = !this.filterFold;
    },
    selectOrigin(key) {
      this.origin_id = key;
      this.form.origin = key;
      this.fetchData(true);
    },
    handleSizeChange($val) {
      this.form.pagesize = $val;
      this.fetchData(true);
    },
    handleCurrentChange(val) {
      this.form.page = val;
      this.fetchData(true);
    },

    fetchData(showLoading) {
      if (showLoading) {
        this.loading = true;
      }
      this.$http.post(this.url, this.form).then((res) => {
        this.loading = false;
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.resData = res.data.data;
          this.resData.current_page = parseInt(this.resData.current_page, 10);
          this.origin_id = this.resData.origin_id;
        }
      });
    },

    search() {
      this.loading = true;
      this.$http.post(this.url, this.form).then((res) => {
        this.loading = false;
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          // this.$message.success(res.data.msg);
          this.fetchData(true);
        }
      });
    },
    clickDialog(value) {
      this.$http
        .post("/erp/WavePickingTempSummary/getUserLabelTagAndImg", {
          uals_id: value.id,
        })
        .then((res) => {
          this.editForm.tag = res.data.data.tag_list;
          this.fileList = res.data.data.img_list;
          this.dialogFormVisible = true;
          this.editForm.user_id = parseInt(value.user_id, 10);
          this.editForm.space_txt = value.space_txt;
          this.editForm.label_note = value.label_note;
        });
    },
    showLog(value) {
      this.loading = true;
      const url = "/erp/WavePickingTempSummary/getUserSpaceLog";
      this.$http.post(url, { user_id: value.user_id }).then((res) => {
        this.loading = false;
        if (res.data.code !== 200) {
          this.$message.error("日志获取失败");
        } else {
          this.dialogTableVisible = true;
          this.gridData = res.data.data;
        }
      });
    },
    closeDialog() {
      this.resetForm();
      this.dialogFormVisible = false;
    },
    save() {
      this.loading = true;
      const url = "/erp/WavePickingTempSummary/saveUserSpace";
      this.editForm.file_list = this.fileList;
      this.$http.post(url, this.editForm).then((res) => {
        this.loading = false;
        this.resetForm();
        this.dialogFormVisible = false;
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.$message.success(res.data.msg);
          this.fetchData(true);
        }
      });
    },
    resetForm() {
      this.editForm = {
        space_txt: "",
        label_note: "",
        user_id: 0,
        tag: [],
        file_list: [],
      };
      this.tempSuccessImg = [];
      this.$refs.example_upload.uploadFiles = [];
      this.fileList = [];
    },
    output() {
      this.loading = true;
      this.form.is_excel = 1;
      this.$http.post(this.url, this.form).then((res) => {
        this.form.is_excel = 0;
        this.loading = false;
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          window.open(apiBaseURL + res.data.data.file);
        }
      });
    },
    reset() {
      this.form.search_user_id = "";
      this.form.space = "";
      this.form.is_label = "";
      this.form.page = 1;
      this.form.pagesize = 50;
      this.fetchData();
    },
    setTag(tag) {
      const isHas = this.editForm.tag.findIndex((item) => {
        return item === tag.value;
      });
      console.log(isHas);
      if (isHas >= 0) {
        this.editForm.tag.splice(isHas, 1);
      } else {
        this.editForm.tag.push(tag.value);
      }
    },
    tagType(tag) {
      if (this.editForm.user_id) {
        const isHas = this.editForm.tag.findIndex((item) => {
          return item === tag.value;
        });
        if (isHas >= 0) {
          return "success";
        }
        return "info";
      }
      return "info";
    },
    remark() {
      this.$refs.label_note_textarea.focus();
    },
    handleImgRemove(file) {
      const index = this.fileList.findIndex((item) => {
        return item.uid === file.uid;
      });
      this.fileList.splice(index, 1);
    },
    handleImgExceed() {
      this.$message.error("一次最多上传5个");
    },
    handleImgSuccess(response, file) {
      if (response.code === 200) {
        this.fileList.push({
          name: file.name,
          url: response.data.url,
          id: file.uid,
          path: response.data.path,
        });
      } else {
        this.$message.error(response.msg);
      }
    },
  },
};
</script>

<style scoped>
.filter {
  border: 1px solid #ddd;
}

.el-row {
  margin-bottom: 20px;
}

.el-row:last-child {
  margin-bottom: 0;
}

.tag {
  margin-left: 20px;
  margin-bottom: 10px;
}

.el-carousel__item img {
  width: 150px;
  height: 150px;
}

.el-carousel__item:nth-child(2n) {
  background-color: #fff;
  text-align: center;
}

.el-carousel__item:nth-child(2n + 1) {
  background-color: #fff;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/pages/wavepicking/LabelUserSpace.vue